import React, { useCallback, useMemo } from 'react';
import { useAuth } from '@/contexts/useAuth';
import { InvestorDocumentsPage } from '../documents/InvestorDocumentsPage';
import { isDocumentVisibleForRoles } from '@/utils/investor/documentVisibility';
import type { Investor, InvestorDocument } from '@/types/investor';

interface DocumentsTabProps {
  investorId: string;
  organizationId: string;
  investor: Investor;
  canManage: boolean;
  onUploadPendingChange?: (pending: boolean) => void;
}

export const DocumentsTab: React.FC<DocumentsTabProps> = ({ investorId, organizationId, investor, canManage, onUploadPendingChange }) => {
  const { user } = useAuth();
  const userRoles = useMemo(
    () => ((user?.roles as string[] | undefined) ?? []).map((role) => role.toLowerCase()),
    [user]
  );

  const isDocumentVisible = useCallback(
    (doc: InvestorDocument) => isDocumentVisibleForRoles(doc, userRoles),
    [userRoles]
  );

  return (
    <InvestorDocumentsPage
      investorId={investorId}
      organizationId={organizationId}
      investor={investor}
      readOnly={!canManage}
      onUploadPendingChange={onUploadPendingChange}
      isDocumentVisible={isDocumentVisible}
    />
  );
};

export default DocumentsTab;
